import React from 'react';
import { Card, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { useSettings } from '../../services/hooks';
import { ParticipantRecord } from '../../sections/employee/record/ParticipantRecord';
import { PurchaserRecord } from '../../sections/employee/record/PurchaserRecord';
import { ResortRecord } from '../../sections/employee/record/ResortRecord';
import { CampRecord } from '../../sections/employee/record/CampRecord';
import { EventRecord } from '../../sections/employee/record/EventRecord';
import { AccomodationRecord } from '../../sections/employee/record/AccomodationRecord';
import { AgeRangeRecord } from '../../sections/employee/record/AgeRangeRecord';
import { SeasonRecord } from '../../sections/employee/record/SeasonRecord';
import { PromotionRecord } from '../../sections/employee/record/PromotionRecord';
import { TransportRecord } from '../../sections/employee/record/TransportRecord';
import { ActivityRecord } from '../../sections/employee/record/ActivityRecord';
import { PeriodRecord } from '../../sections/employee/record/PeriodRecord';
import { PaymentDateRangeRecord } from '../../sections/employee/record/PaymentDateRangeRecord';
import { SlotsControlRecord } from '../../sections/employee/record/SlotsControlRecord';
import { TransportSeatsRecord } from '../../sections/employee/record/TransportSeatsRecord';
import DietRecord from '../../sections/employee/record/DietRecord';
import { BonusRecord } from '../../sections/employee/record/BonusRecord';
import { NewsBanerRecord } from '../../sections/employee/record/NewsBanerRecord';
import { PackageRecord } from '../../sections/employee/record/PackageRecord';
import { SunActiveCategoryRecord } from '../../sections/employee/record/SunActiveCategoryRecord';
import { AvailabilityStatusRecord } from '../../sections/employee/record/AvailabilityStatusRecord';
import { PiggyBankRecord } from '../../sections/employee/record/PiggyBankRecord';
import { ActivityCategoryRecord } from '../../sections/employee/record/ActivityCategoryRecord';

export const Record = () => {
  const { themeStretch } = useSettings();
  const { module, seasonYear } = useSelector(state => state.app);
  const [currentTab, setCurrentTab] = React.useState(
    module === 'zielone_szkoly' ? 'zajęcia' : 'imprezy'
  );

  React.useEffect(() => {
    if (module == 'zielone_szkoly') {
      setCurrentTab('zajęcia');
    } else if (module == 'rekrutacja') {
      setCurrentTab('bonusy');
    };
  }, [module]);

  const ACCOUNT_TABS = [
    {
      value: 'imprezy',
      icon: (
        <Iconify icon={'ic:baseline-emoji-events'} width={20} height={20} />
      ),
      component: <EventRecord />
    },
    {
      value: 'turnusy',
      icon: <Iconify icon={'ic:baseline-campaign'} width={20} height={20} />,
      component: <CampRecord />
    },
    {
      value: 'ośrodki',
      icon: <Iconify icon={'ic:baseline-place'} width={20} height={20} />,
      component: <ResortRecord />
    },
    {
      value: 'sezony',
      icon: <Iconify icon={'ic:baseline-cloud'} width={20} height={20} />,
      component: <SeasonRecord />
    },
    {
      value: 'zakwaterowania',
      icon: <Iconify icon={'ic:baseline-house'} width={20} height={20} />,
      component: <AccomodationRecord />
    },
    {
      value: 'promocje',
      icon: <Iconify icon={'ic:baseline-discount'} width={20} height={20} />,
      component: <PromotionRecord />
    },
    {
      value: 'dostępność miejsc',
      icon: <Iconify icon={'ic:baseline-event-seat'} width={20} height={20} />,
      component: <AvailabilityStatusRecord />
    },
    {
      value: 'przedziały wiekowe',
      icon: <Iconify icon={'ic:baseline-date-range'} width={20} height={20} />,
      component: <AgeRangeRecord />
    },
    {
      value: 'transporty',
      icon: (
        <Iconify icon={'ic:baseline-directions-bus'} width={20} height={20} />
      ),
      component: <TransportRecord />
    },
    {
      value: 'transporty miejsca',
      icon: <Iconify icon={'mdi:seat-passenger'} width={20} height={20} />,
      component: <TransportSeatsRecord />
    },
    {
      value: 'zamawiający',
      icon: <Iconify icon={'ic:round-account-box'} width={20} height={20} />,
      component: <PurchaserRecord />
    },
    {
      value: 'uczestnicy',
      icon: <Iconify icon={'ic:baseline-co-present'} width={20} height={20} />,
      component: <ParticipantRecord />
    },
    {
      value: 'diety',
      icon: (
        <Iconify icon={'mdi:silverware-fork-knife'} width={20} height={20} />
      ),
      component: <DietRecord />
    },
    {
      value: 'skarbonka',
      icon: <Iconify icon={'ic:baseline-savings'} width={20} height={20} />,
      component: <PiggyBankRecord />
    }
  ];

  const ZIELONE_SZKOLY_TABS = [
    {
      value: 'zajęcia',
      icon: (
        <Iconify icon={'ic:baseline-emoji-events'} width={20} height={20} />
      ),
      component: <ActivityRecord />
    },
    {
      value: 'kategorie zajęć',
      icon: <Iconify icon={'ic:baseline-cloud'} width={20} height={20} />,
      component: <ActivityCategoryRecord />
    },
    {
      value: 'kontrola miejsc',
      icon: <Iconify icon={'ic:baseline-house'} width={20} height={20} />,
      component: <SlotsControlRecord />
    },
    {
      value: 'przedziały czasowe płatności',
      icon: <Iconify icon={'ic:baseline-date-range'} width={20} height={20} />,
      component: <PaymentDateRangeRecord />
    },
    {
      value: 'terminy',
      icon: <Iconify icon={'ic:baseline-campaign'} width={20} height={20} />,
      component: <PeriodRecord />
    },
    {
      value: 'pakiety',
      icon: <Iconify icon={'ic:round-list-alt'} width={20} height={20} />,
      component: <PackageRecord />
    },
    {
      value: 'diety',
      icon: (
        <Iconify icon={'mdi:silverware-fork-knife'} width={20} height={20} />
      ),
      component: <DietRecord />
    },
    {
      value: 'ośrodki',
      icon: <Iconify icon={'ic:baseline-place'} width={20} height={20} />,
      component: <ResortRecord />
    },
    {
      value: 'sezony',
      icon: <Iconify icon={'ic:baseline-cloud'} width={20} height={20} />,
      component: <SeasonRecord />
    },
    {
      value: 'promocje',
      icon: <Iconify icon={'ic:baseline-discount'} width={20} height={20} />,
      component: <PromotionRecord />
    },
    {
      value: 'zamawiający',
      icon: <Iconify icon={'ic:round-account-box'} width={20} height={20} />,
      component: <PurchaserRecord />
    },
    {
      value: 'uczestnicy',
      icon: <Iconify icon={'ic:baseline-co-present'} width={20} height={20} />,
      component: <ParticipantRecord />
    }
  ];

  const RECRUITMENT_TABS = [
    {
      value: 'bonusy',
      icon: (
        <Iconify icon={'ic:baseline-emoji-events'} width={20} height={20} />
      ),
      component: <BonusRecord />
    },
    {
      value: 'baner - aktualności',
      icon: (
        <Iconify icon={'ic:baseline-emoji-house'} width={20} height={20} />
      ),
      component: <NewsBanerRecord />
    },
    {
      value: 'Kategorie Sun Active',
      icon: (
        <Iconify icon={'ic:baseline-emoji-events'} width={20} height={20} />
      ),
      component: <SunActiveCategoryRecord />
    }
  ];

  const POLKOKLONIE_SKIP_TABS = [
    'zakwaterowania',
    'transporty',
    'transporty miejsca',
    'ośrodki',
    'skarbonka',
    'dostępność miejsc'
  ];

  const OBOZY_2027_BELOW_SKIP_FIELDS = [
    'skarbonka',
    'dostępność miejsc'
  ];

  const WYJAZDY_RODZINNE_TABS = [
    {
      value: 'zajęcia',
      icon: (
        <Iconify icon={'ic:baseline-emoji-events'} width={20} height={20} />
      ),
      component: <ActivityRecord />
    },
    {
      value: 'terminy',
      icon: <Iconify icon={'ic:baseline-campaign'} width={20} height={20} />,
      component: <PeriodRecord />
    },
    {
      value: 'ośrodki',
      icon: <Iconify icon={'ic:baseline-place'} width={20} height={20} />,
      component: <ResortRecord />
    },
    {
      value: 'diety',
      icon: (
        <Iconify icon={'mdi:silverware-fork-knife'} width={20} height={20} />
      ),
      component: <DietRecord />
    },
    {
      value: 'zakwaterowania',
      icon: <Iconify icon={'ic:baseline-house'} width={20} height={20} />,
      component: <AccomodationRecord />
    },
    {
      value: 'promocje',
      icon: <Iconify icon={'ic:baseline-discount'} width={20} height={20} />,
      component: <PromotionRecord />
    },
    {
      value: 'zamawiający',
      icon: <Iconify icon={'ic:round-account-box'} width={20} height={20} />,
      component: <PurchaserRecord />
    }
  ];

  return (
    <Page title="Kartoteki">
      {module == 'rekrutacja' ? (
        <Card
          sx={{
            height: { md: 'calc(100vh - 180px)' },
            display: { md: 'flex' },
            flexDirection: 'column'
          }}
        >
          <Tabs
            value={currentTab}
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
            onChange={(e, value) => setCurrentTab(value)}
            sx={{ mb: 1 }}
          >
            {RECRUITMENT_TABS.map(tab => <Tab
              disableRipple
              key={tab.value}
              label={tab.value}
              icon={tab.icon}
              value={tab.value}
            />)}
          </Tabs>

          {RECRUITMENT_TABS.map(tab => {
            const isMatched = tab.value === currentTab;

            return (
              isMatched && (
                <div style={{ height: 'calc(100% - 120px)' }} key={tab.value}>
                  {tab.component}
                </div>
              )
            );
          })}
        </Card>
      ) : module == 'zielone_szkoly' ? (
        <Card
          sx={{
            height: {
              md:
                currentTab !== 'kontrola miejsc'
                  ? 'calc(100vh - 180px)'
                  : '120vh'
            },
            display: { md: 'flex' },
            flexDirection: 'column'
          }}
        >
          <Tabs
            value={currentTab}
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
            onChange={(e, value) => setCurrentTab(value)}
            sx={{ mb: 1 }}
          >
            {ZIELONE_SZKOLY_TABS.map(tab => (
              <Tab
                disableRipple
                key={tab.value}
                label={tab.value}
                icon={tab.icon}
                value={tab.value}
              />
            ))}
          </Tabs>

          {ZIELONE_SZKOLY_TABS.map(tab => {
            const isMatched = tab.value === currentTab;

            return (
              isMatched && (
                <div
                  style={
                    currentTab === 'zajęcia' || currentTab === 'kontrola miejsc'
                      ? { flex: 1 }
                      : { height: 'calc(100% - 120px)' }
                  }
                  key={tab.value}
                >
                  {tab.component}
                </div>
              )
            );
          })}
        </Card>
      ) : module === 'wyjazdy_rodzinne' ? (
        <Card
          sx={{
            height: { md: 'calc(100vh - 180px)' },
            display: { md: 'flex' },
            flexDirection: 'column'
          }}
        >
          <Tabs
            value={currentTab}
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
            onChange={(e, value) => setCurrentTab(value)}
            sx={{ mb: 1 }}
          >
            {WYJAZDY_RODZINNE_TABS.map(tab => (
              <Tab
                disableRipple
                key={tab.value}
                label={tab.value}
                icon={tab.icon}
                value={tab.value}
              />
            ))}
          </Tabs>

          {WYJAZDY_RODZINNE_TABS.map(tab => {
            const isMatched = tab.value === currentTab;

            return (
              isMatched && (
                <div style={{ height: 'calc(100% - 120px)' }} key={tab.value}>
                  {tab.component}
                </div>
              )
            );
          })}
        </Card>
      ) : (
        <Card
          sx={{
            height: { md: 'calc(100vh - 180px)' },
            display: { md: 'flex' },
            flexDirection: 'column'
          }}
        >
          <Tabs
            value={currentTab}
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
            onChange={(e, value) => setCurrentTab(value)}
            sx={{ mb: 1 }}
          >
            {ACCOUNT_TABS.map(tab => {
              if (
                module === 'polkolonie' &&
                !POLKOKLONIE_SKIP_TABS.includes(tab.value)
              ) {
                return (
                  <Tab
                    disableRipple
                    key={tab.value}
                    label={tab.value}
                    icon={tab.icon}
                    value={tab.value}
                  />
                );
              } else if (module === 'obozy') {
                if (seasonYear < 2027) {
                  if (OBOZY_2027_BELOW_SKIP_FIELDS.includes(tab.value)) {
                    return null;
                  }
                }

                return (
                  <Tab
                    disableRipple
                    key={tab.value}
                    label={tab.value}
                    icon={tab.icon}
                    value={tab.value}
                  />
                );
              }

              return null;
            })}
          </Tabs>

          {ACCOUNT_TABS.map(tab => {
            const isMatched = tab.value === currentTab;

            return (
              isMatched && (
                <div style={{ height: 'calc(100% - 120px)' }} key={tab.value}>
                  {tab.component}
                </div>
              )
            );
          })}
        </Card>
      )}
    </Page>
  );
};
